// @ts-ignore
import noImage from '@/presentation/assets/images/noimage.png';
function formatePdfImageData(patentImg) {
    if (patentImg && patentImg.resolution) {
        if (!patentImg.pp_bbox) {
            return {
                type: 'offical',
                src: noImage,
                originSrc: noImage,
                hasImg: false,
            };
        }
        const boxArr = patentImg.resolution.split('x');
        const { x1, y1, x2, y2 } = patentImg.pp_bbox;
        const model = {
            id: patentImg.page_index,
            path: patentImg.url,
            oriWidth: boxArr[0],
            oriHeight: boxArr[1],
            box: [x1, y1, x2, y2],
        };
        return {
            model,
            originSrc: noImage,
            type: 'patsnap',
            hasImg: true,
        };
    }
    if (patentImg && patentImg.url) {
        return {
            type: 'offical',
            src: patentImg.url,
            originSrc: patentImg.originSrc,
            hasImg: true,
        };
    }
    return {
        type: 'offical',
        src: noImage,
        originSrc: noImage,
        hasImg: false,
    };
}
export { formatePdfImageData };
